"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "./cookie-consent-provider";

export function CookieBanner() {
  const { showBanner, acceptAll, openPreferences } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-4xl rounded-lg border border-border/50 bg-background/95 p-6 shadow-2xl backdrop-blur-md">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <h3 className="font-sans text-lg font-semibold text-foreground">
              Configuración de Cookies
            </h3>
            <p className="font-mono text-sm leading-relaxed text-muted-foreground">
              Utilizamos cookies para analizar el tráfico y mejorar nuestros
              servicios. Las cookies de marketing nos ayudan a medir la
              efectividad de nuestras campañas. Puede aceptar todas o
              personalizar sus preferencias.{" "}
              <Link
                href="/cookies"
                className="text-primary underline underline-offset-2 hover:text-primary/80"
              >
                Más información
              </Link>
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={openPreferences}
              className="order-2 sm:order-1"
            >
              Personalizar
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={acceptAll}
              className="order-1 sm:order-2"
            >
              Aceptar todo
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
